import type { ComponentProps } from 'react';
import { Header } from '@backstage/core-components';
import { Text } from '@backstage/ui';
import { useNewFrontendSystem } from './newFrontendSystem';
import styles from './VariaPageHeader.module.css';

type VariaPageHeaderProps = ComponentProps<typeof Header> & {
  /** For routes nested inside an NFS page, whose title differs from the native plugin header. */
  subPage?: boolean;
};

/**
 * Gradient page header for pages served by an NFS `PageBlueprint`.
 * Hidden when `new-frontend-system` is on, since the framework then renders the native plugin header.
 */
export const VariaPageHeader = ({ subPage, ...props }: VariaPageHeaderProps) => {
  const newFrontendSystem = useNewFrontendSystem();

  if (!newFrontendSystem) {
    return <Header {...props} />;
  }

  if (subPage) {
    return (
      <div className={`${styles.subheader} ${styles.subPage}`}>
        <Text as="h2" variant="title-small">
          {props.title}
        </Text>
        {props.children && <div className={styles.actions}>{props.children}</div>}
      </div>
    );
  }

  if (!props.children) {
    return null;
  }

  return <div className={`${styles.subheader} ${styles.actions}`}>{props.children}</div>;
};
